import React from "react";
import Button from "../../../../../_components/Button";
import Modal from "../../../../../_components/Modal";
import ReCAPTCHA from "react-google-recaptcha";
import ImportProductFromNFeXML from "../NFeXML";
import ImportProductFromCSV from "../ProductCSV";

import Page from "../../../../../_components/Layout/Page";
import Row from "../../../../../_components/Layout/Row";
import Column from "../../../../../_components/Layout/Column";

export default (props) => {
  const [show, setShow] = React.useState(false);
  const [passedCaptcha, setPassedCaptcha] = React.useState(true);
  return (
    <React.Fragment>
      <Button onClick={() => setShow(true)} className="my-3">
        Importar via XML ou CSV
      </Button>
      <Modal
        title="Importar produto via XML ou CSV"
        show={show}
        onHide={() => {
          setPassedCaptcha(false), setShow(false);
        }}
      >
        <Page>
          <Row>
            <Column col="">
              <div className="d-flex justify-content-center">
                <ReCAPTCHA
                  hidden={passedCaptcha}
                  sitekey="6LdfmIUlAAAAAJUK2xhCmFq0YwpvelFOLAXSFuHw"
                  onChange={() => {
                    setTimeout(() => {
                      setPassedCaptcha(true);
                    }, 500);
                  }}
                />
              </div>
            </Column>
            <Column col="12" hide={!passedCaptcha}>
              <div className="d-flex justify-content-center">
                <div className="d-flex justify-content-evenly">
                  <ImportProductFromNFeXML
                    closeFirstModal={() => {
                      setShow(false);
                    }}
                  />
                  <div style={{ marginInline: 10 }} />
                  <ImportProductFromCSV
                    closeFirstModal={() => {
                      setShow(false);
                    }}
                  />
                </div>
              </div>
            </Column>
          </Row>
        </Page>
      </Modal>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/imports/ProductCSV/Button.jsx